module.exports = __webpack_public_path__ + "assets/icon-variation-up.31b3d676.svg";